<template>
  <!-- style="overflow-y: auto;position: absolute;left: 0;right: 0;top: 0;bottom: 0;" -->
  <div>
    <!-- 头部 -->
    <div class="header">
      <header-tag :title="'OEM信息设置'"></header-tag>
    </div>
    <!-- 表单部分 -->
    <div class="body">
      <div
        class="subTitle"
        style="border:none;"
      >
        <header-tag :title="'自定义专属域名'"></header-tag>
      </div>
      <div
        class="form-body"
        style="border-bottom: 2px dashed rgb(230, 230, 230);"
      >
        <div class="form-left">
          <p>
            <input
              type="radio"
              :checked="!domainRadio"
              @click="radioStatus"
            />
            二级域名(VIP)：
          </p>
          <p>
            <input
              type="radio"
              :checked="domainRadio"
              :disabled="
                                $store.state.user.userInfo.judgeVip == 2
                                    ? true
                                    : false
                            "
              @click="(domainRadio = true), (secondText = '')"
            />
            一级域名(SVIP)：
          </p>
        </div>
        <div class="form-right">
          <p>
            <input
              type="text"
              placeholder="支持英文、数字、-，最长16位"
              style="width:200px;"
              v-model="secondText"
              :disabled="domainRadio ? true : false"
            />
            .weihudashi.com
          </p>
          <p>
            <input
              type="text"
              placeholder="www.abckj.com"
              v-model="firstText"
              :disabled="
                                $store.state.user.userInfo.judgeVip == 2 ||
                                !domainRadio
                                    ? true
                                    : false
                            "
            />
            <a
              href="https://123.weihudashi.com/1190/"
              target="_blank"
              style="margin-left:10px;"
            >设置教程</a>
          </p>
          <p class="tips">
            使用自定义域名访问平台时，会根据你的自定义信息显示相应信息，彰显贵团队品牌与专业性。
          </p>
        </div>
      </div>
      <div class="subTitle">
        <header-tag :title="'自定义Web端标题'"></header-tag>
      </div>
      <div
        class="form-body"
        style="border-bottom: 2px dashed rgb(230, 230, 230);"
      >
        <div class="form-left">
          <p>自定义标题名：</p>
        </div>
        <div class="form-right">
          <p>
            <input
              type="text"
              v-model="webTitle"
              maxlength="16"
              placeholder="维护大师远程管理平台"
            />
          </p>
          <p class="tips">
            最大16个汉字，支持特殊符号，示意图如下，访问自定义域名时将出现如下效果：
          </p>
          <p class="webTitle">
            <span
              v-text="webTitle"
              style="width: 186px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;"
            ></span>
            <img
              src="@/assets/img/icon/u679.png"
              alt=""
            />
          </p>
        </div>
      </div>
      <div class="subTitle">
        <header-tag :title="'自定义Web端Logo'"></header-tag>
      </div>
      <div class="form-body">
        <div class="form-left">
          <p style="line-height: normal;height: 185px;">
            登录前Logo：
          </p>
          <p style="line-height: normal;">登录后Logo：</p>
        </div>
        <div class="form-right">
          <p>
            <img-upload
              ref="imgUploadBefore"
              :file="imgBefore"
              :url="beforeUrl"
              @fileResult="fileResultBefore"
            ></img-upload>
          </p>
          <p class="tips">
            尺寸及文件格式：图片最大宽度为280,高度为30，png格式，下方白色Logo及文字为logo定制样式（背景色#252A2F）：
          </p>
          <p
            class="preview"
            style="margin-bottom:20px;"
          >
            <img
              :src="imgBefore"
              alt=""
            />
          </p>
          <p>
            <img-upload
              ref="imgUploadAfter"
              :file="imgAfter"
              :url="afterUrl"
              @fileResult="fileResultAfter"
            ></img-upload>
          </p>
          <p class="tips">
            尺寸及文件格式：图片最大宽度为280,高度为30，png格式，下方白色蓝色Logo及白色文字为logo定制样式（背景色#252A2F）：
          </p>
          <p class="preview">
            <img
              :src="imgAfter"
              alt=""
            />
          </p>
        </div>
      </div>
      <div
        class="form-body"
        style="border-top: 2px dashed rgb(230, 230, 230);"
      >
        <div
          class="form-left"
          style="height:30px;"
        ></div>
        <div class="form-right">
          <p>
            <button
              @click="comfirm"
              class="comfirm"
            >保存</button>
            <span
              v-text="msg"
              style="margin-left:5px;color:tomato;"
            ></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderTag from '_c/tagTitle/headerTag'; // 引入头部组件
import ImgUpload from '_c/uploadImg'; // 引入上传图片组件
import { setOEMInformation, getOEMInformation } from '@/requests/user'; // 用户信息修改
import { mapActions } from 'vuex';
export default {
  name: 'OEMInfo',
  components: {
    HeaderTag,
    ImgUpload,
  },
  data() {
    return {
      msg: '', // 提示信息
      id: '',
      webTitle: '维护大师远程管理平台',
      imgBefore: '',
      imgAfter: '',
      domainRadio: false,
      firstText: '',
      secondText: '',
      domainName: '',
      afterUrl: this.$HTTP_API.user.uploadImg + '?logoType=2',
      beforeUrl: this.$HTTP_API.user.uploadImg + '?logoType=1',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getUser();
    });
  },
  methods: {
    ...mapActions(['user/actionSetOEMInfo']),
    // 获取用户信息
    async getUser() {
      let res = await getOEMInformation();
      if (res.data) {
        this.id = res.data.id;
        this.webTitle = res.data.webTitle;
        this.imgBefore = res.data.beforeLoginLogo;
        this.imgAfter = res.data.afterLoginLogo;
        if (res.data.domainType == 1) {
          this.domainRadio = true;
          this.firstText = res.data.domainName;
        } else if (res.data.domainType == 2) {
          this.domainRadio = false;
          this.secondText = res.data.domainName;
        }
      }
    },
    radioStatus() {
      this.domainRadio = false;
      this.firstText = '';
    },
    fileResultBefore(data) {
      this.imgBefore = data;
    },
    fileResultAfter(data) {
      this.imgAfter = data;
    },
    // 信息修改提交
    async comfirm() {
      if (this.domainRadio) {
        this.domainName = this.firstText;
      } else {
        this.domainName = this.secondText;
      }
      let res = await setOEMInformation({
        id: this.id,
        domainType: this.domainRadio ? 1 : 2,
        domainName: this.domainName,
        webTitle: this.webTitle,
        beforeLoginLogo: this.imgBefore,
        afterLoginLogo: this.imgAfter,
      });
      if (res.code == 200) {
        window.$Message.show({
          title: '特权功能',
          type: 'success',
          msg: '保存成功。',
          confirmFn: async () => {
            window.$Message.hide();
          },
        });
        this['user/actionSetOEMInfo']();
        if (this.$Cookie.getCookie('beforeLoginLogo')) {
          this.$Cookie.delCookie('beforeLoginLogo');
        }
        if (this.$Cookie.getCookie('afterLoginLogo')) {
          this.$Cookie.delCookie('afterLoginLogo');
        }
        if (this.$Cookie.getCookie('webTitle')) {
          this.$Cookie.delCookie('webTitle');
        }
        this.imgBefore
          ? this.$Cookie.setCookie('beforeLoginLogo', this.imgBefore)
          : '';
        this.imgAfter
          ? this.$Cookie.setCookie('afterLoginLogo', this.imgAfter)
          : '';
        // this.webTitle
        //   ? this.$Cookie.setCookie("webTitle", this.webTitle)
        //   : "";
      } else {
        /* eslint-disable */
        console.log(res.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "_style/msgbox/_comMsg.scss";

.header {
  padding-left: 30px;
  text-align: left;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}
.subTitle {
  padding-left: 30px;
  text-align: left;
  height: 50px;
  line-height: 50px;
}
.form-body {
  overflow: hidden;
  margin-left: 50px;
  width: 90%;
  padding: 10px 0px 20px 0px;
  .form-left {
    float: left;
    width: 150px;
    text-align: left;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }
  .form-right {
    float: left;
    padding-left: 15px;
    text-align: left;
    line-height: 40px;
    input {
      width: 310px;
      border: 1px solid rgb(230, 230, 230);
      padding-left: 10px;
      height: 30px;
      font-size: 12px;
      color: rgb(81, 81, 81);
    }
    button.comfirm {
      width: 100px;
      line-height: 30px;
      color: #fff;
      background-color: rgb(0, 153, 204);
    }
  }
}
.tips {
  font-size: 12px;
  color: #a1a1a1;
  line-height: 30px;
}
.preview {
  width: 300px;
  height: 60px;
  background: rgb(37, 42, 47);
  position: relative;
  img {
    max-width: 280px;
    height: 30px;
    margin: 0 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.webTitle {
  position: relative;
  span {
    position: absolute;
    left: 44px;
    font-size: 12px;
    line-height: normal;
    top: 10px;
  }
}
</style>
